import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";
import { useLang } from "../i18n";

const BackToTop = () => {
  const { t } = useLang();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!show) return null;
  return (
    <button
      data-testid="back-to-top"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label={t("back_top")}
      title={t("back_top")}
      className="fixed bottom-24 right-6 z-40 w-10 h-10 rounded-full border border-white/20 bg-black/70 backdrop-blur-xl flex items-center justify-center text-mist hover:text-ember hover:border-ember hover:-translate-y-0.5 transition-all shadow-lg"
    >
      <ArrowUp className="w-4 h-4" />
    </button>
  );
};

export default BackToTop;
